import { inject, Injectable, signal } from '@angular/core';
import { BrowserPlatformService } from './browser-platform.service';

const STORAGE_KEY = 'cmsShowTestErrors';

@Injectable({ providedIn: 'root' })
export class ErrorAlertDebugService {
  private readonly browser = inject(BrowserPlatformService);

  readonly isAvailable = signal(false);
  readonly showTestErrors = signal(false);

  setAvailable(value: boolean): void {
    this.isAvailable.set(value);

    if (value) {
      this.showTestErrors.set(this.readStoredValue());
      return;
    }

    this.showTestErrors.set(false);
  }

  setShowTestErrors(value: boolean): void {
    if (!this.isAvailable()) {
      this.showTestErrors.set(false);
      return;
    }

    this.showTestErrors.set(value);
    this.writeStoredValue(value);
  }

  toggleShowTestErrors(): void {
    this.setShowTestErrors(!this.showTestErrors());
  }

  private readStoredValue(): boolean {
    return this.browser.getLocalStorageItem(STORAGE_KEY) === '1';
  }

  private writeStoredValue(value: boolean): void {
    if (value) {
      this.browser.setLocalStorageItem(STORAGE_KEY, '1');
    } else {
      this.browser.removeLocalStorageItem(STORAGE_KEY);
    }
  }
}
